import { getAllReportsSelector } from "./getAllReportsSelector";
import { RootState } from "../../store";
import { Report } from "../../../services/cloudchipr.api";

export const allReportsSelector = (state: RootState): Report[] | undefined => {
  return getAllReportsSelector(state).data;
};
